module.exports = __webpack_public_path__ + "static/media/randomlo4.7f3cffaa.jpg";